import { useEffect } from "react";
const PaymentMethods = ({
    gateways,
    selectedPayment,
    setSelectedPayment,
}) => {

    useEffect(() => {
        if (gateways?.length > 0 && !selectedPayment) {
            setSelectedPayment({
                provider: gateways[0].provider,
                secret: gateways[0].secret
            });
        }
    }, [gateways, selectedPayment, setSelectedPayment]);

    return (
        <div className="section mb-2">
            <h6 style={{ fontSize:"14px", color:"#676464" }}>
                  Select Payment Method:
            </h6>

            <div className="payment-options">
                {gateways?.map((pg, idx) => (
                    <label key={idx} className="payment-option">
                        <input
                            type="radio"
                            name="payment"
                            checked={selectedPayment?.provider === pg.provider}
                            onChange={() =>
                                setSelectedPayment({
                                    provider: pg.provider,
                                    key_id: pg.key_id,
                                })
                            }
                        />
                          <img src={pg.logo} alt={pg.provider} className="payment-logo"/>
                    </label>
                ))}
            </div>
        </div>
    );
};
export default PaymentMethods;